export default "__VITE_ASSET__85559dfa__"